import merchant from './merchant';
import aggregator from './aggregator';

const client = {
  namespaced: true,

  state() {
    return {};
  },

  mutations: {},

  actions: {},

  modules: {
    merchant,
    aggregator,
  },
};
export default client;
